<!-- 解决方案/智能制造能力 -->
<template>
  <div class="solution">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 方案简介 -->
    <Introduction :title="propsCon.title" :content="propsCon.content" :image="propsCon.img"></Introduction>
    <!-- 模型等级 -->
    <div class="modelCon">
      <ModelImg
        :title="modelCon.title"
        :content="modelCon.content"
        :image="modelCon.img"
        :bgimage="modelCon.bgImg"
      ></ModelImg>
      <ListItem :modelList="modelList" class="listModel"></ListItem>
    </div>
    <!-- 底部流程 -->
    <Follow></Follow>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Introduction from '../components/Introduction'
import ModelImg from '../components/ModelImg'
import ListItem from '../components/ListItem'
import Follow from '../components/Follow'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Introduction, ModelImg, ListItem, Follow, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '智能制造能力咨询评估',
        bgImg: require('../assets/images/u16.png'),
        content:
          '智能制造能力成熟度模型是用于评估智能制造当前状态的工具、建立智能制造战略目标和实施规划的框架。一是通过线上线下结合的方式对企业智能制造的当前现状及水平进行评估，为企业提供专业、详细的评估分析报告，让企业了解自身智能制造情况，为下一步开展智能制造规划提供参考；二是与企业智能制造实际情况进行对标，得出智能制造能力等级，发现差距并持续改进，提升企业的智能制造能力水平。',
        bl: true,
      },
      propsCon: {
        title: '方案简介',
        content: [
          ' 这项服务不仅能够帮助制造企业识别差距、评价效果、确定目标，助力解决方案供应商把握企业真实需求、促进提升技术实现的路径方法，还能协助投资方掌握智能制造发展趋势及企业水平潜力，优化投资判断，明确投资方向，并为政府掌握辖区内行业企业智能制造水平、选择标杆示范、判断工作阶段性成果及后续扶持方向，提供有力的依据与保障。',
        ],
        img: require('../assets/images/u887.png'),
      },
      modelCon: {
        title: '模型等级',
        content: [
          '智能制造能力成熟度：智能制造能力的5个等级，覆盖设计、生产、物流、销售、服务、资源要素、互联互通、系统集成、信息融合、新兴业态等10个方面。',
        ],
        img: require('../assets/images/u864.png'),
        bgImg: require('../assets/images/u861.png'),
      },
      modelList: [
        {
          title: '规划级',
          content: [
            ' 企业有了实施智能制造的想法，开始进行规划和投资。部分核心的制造环节已实现业务流程信息化，具备部分满足未来通信和集成需求的基础设施，企业已开始基于IT进行制造活动，单只是具备实施智能制造的基础条件，还未真正进入到智能制造的范畴',
          ],
          img: require('../assets/images/u216.png'),
        },
        {
          title: '规范级',
          content: [
            ' 企业已经形成了智能制造的规划，对支撑核心业务的设备和系统进项了投资，通过技术改造，使得主要设备数据采集和通信的能力，实现了覆盖核心业务重要环节的自动化、数字化升级。通过制定标准化的接口和数据格式，部分支撑生产作业的信息系统能够实现内部集成，数据和信息在业务内部实现共享，企业开始迈进智能制造的门槛',
          ],
          img: require('../assets/images/u219.png'),
        },
        {
          title: '集成级',
          content: [
            ' 企业对智能制造的投资重点开始从对基础设施、生产装备和信息系统等的单项投入，向集成实施转变，重要的制造业务、生产设备、生产单元完成数字化、网络化改造，能够实现设计、生产、销售、物流、服务等核心业务间的信息系统集成，开始聚焦工厂范围内数据的共享，企业已完成了智能化提升的准备工作',
          ],
          img: require('../assets/images/u384.png'),
        },
        {
          title: '优化级',
          content: [
            ' 企业内生产系统、管理系统以及其他支撑系统已完成全面集成，实现了工厂级的数字建模，并开始对人员、装备、产品、环境所采集到的数据以及生产过程中所形成的数据进行分析，通过知识库、专家库等优化生产工艺和业务流程，能够实现信息世界与物理世界互动。从三级到四级体现了量变到质变的过程，企业只能制造的能力快速提升',
          ],
          img: require('../assets/images/u225.png'),
        },
        {
          title: '引领级',
          content: [
            ' 智能制造能力建设的最高程度，在这个级别下，数据的分析使用已贯穿企业的方方面面，各类生产资源都得以最优化的利用，设备之间实现自治的反馈和优化，企业已成为上下游产业链中的重要角色，个性化定制、网络协同、远程运维已成为企业开展业务的主要模式，企业成为本行业智能制造的标杆',
          ],
          img: require('../assets/images/u381.png'),
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="less">
.modelCon {
  position: relative;
}
.listModel {
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%, 50%);
  -moz-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
  bottom: 0;
  width: 100%;
}
</style>
